import untils from "../untils";
export default {
  // permissionTree(state) {//获取权限
  //   return untils.array2Tree(state.permissionList, "PARENT_ID");
  // },
  size: state => state.size,
  permissionTree() {
    //获取权限
    return [
      {
        NAME: "首页",
        PERMISSION: "/home/index",
        children: []
      },
      {
        NAME: "导航",
        PERMISSION: "/home/menu",
        children: [
          {
            NAME: "表格",
            PERMISSION: "/home/menu/tableList"
          },
          {
            NAME: "导航子页面",
            PERMISSION: "/home/menu/page2"
          }
        ]
      },
      {
        NAME: "视频",
        PERMISSION: "/home/video",
        children: []
      }
    ];
  }
};
